// extracted by mini-css-extract-plugin
export default {"filesWrap":"FileList_filesWrap__D4gdP","header_wrap":"FileList_header_wrap__l5-nv","noFilesBut":"FileList_noFilesBut__FZgXb"};